import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { StorePageTracker, StoreEventTracker } from '../helper/analytics-tracker';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    StorePageTracker.trackPageView();
  }, [location.pathname, location.search]);
};

export const useAnalytics = () => {
  const trackEvent = useCallback((eventType: string, eventData?: Record<string, any>) => {
    StoreEventTracker.trackStoreEvent(eventType, eventData);
  }, []);

  const trackProductView = useCallback((productId: string, category?: string, price?: number) => {
    StoreEventTracker.trackProductView(productId, category, price);
  }, []);

  const trackAddToCart = useCallback((productId: string, quantity: number, price: number) => {
    StoreEventTracker.trackAddToCart(productId, quantity, price);
  }, []);

  const trackRemoveFromCart = useCallback((productId: string, quantity: number, price: number) => {
    StoreEventTracker.trackRemoveFromCart(productId, quantity, price);
  }, []);

  const trackCheckoutStep = useCallback((step: string, cartValue: number, itemCount?: number) => {
    StoreEventTracker.trackCheckoutStep(step, cartValue, itemCount);
  }, []);

  const trackPurchase = useCallback((orderId: string, totalValue: number, itemCount: number, paymentMethod?: string) => {
    StoreEventTracker.trackPurchase(orderId, totalValue, itemCount, paymentMethod);
  }, []);

  const trackSearch = useCallback((query: string, resultsCount?: number) => {
    StoreEventTracker.trackSearch(query, resultsCount);
  }, []);

  const trackUserRegistration = useCallback((method: string = 'email') => {
    StoreEventTracker.trackUserRegistration(method);
  }, []);

  const trackUserLogin = useCallback((method: string = 'email') => {
    StoreEventTracker.trackUserLogin(method);
  }, []);

  return {
    trackEvent,
    trackProductView,
    trackAddToCart,
    trackRemoveFromCart,
    trackCheckoutStep,
    trackPurchase,
    trackSearch,
    trackUserRegistration,
    trackUserLogin
  };
};